import { useMyTranslations } from '@hooks/useMyTranslations';
import { PageHeader } from '@components/Core/PageHeader';
import { ProfileForm } from '@forms/ProfileForm';
import { ProfileTransFields } from './types';
import { profileTranslations } from './translations';

function Profile() {
  const { t } = useMyTranslations<ProfileTransFields>([profileTranslations.name]);

  return (
    <div className="page-container">
      <PageHeader text={t('Edit Profile')} />
      <ProfileForm />
    </div>
  );
}

export default Profile;
